module.exports = __webpack_public_path__ + "static/media/twitterLight.e5cc01ca.svg";